import { RowCrudStatus } from "../../common/types";
import { AiSearchConversation } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { graphqlToDateTime } from "../../../common/utils";

export type AiSearchConversationValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type AiSearchConversationErrorsType = {};

export function AiSearchConversationValuesInit(): AiSearchConversationValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type AiSearchConversationType =
  | AiSearchConversation
  | AiSearchConversationValuesType;

export function aiSearchConversationDisplayId(
  source: Partial<AiSearchConversation>,
  _langStore: LangStore
) {
  return `${graphqlToDateTime(source.startedAt)}`;
}

export function getAiSearchConversationValues(
  source: AiSearchConversationType,
  _langStore: LangStore,
  _duplicated: boolean = false
): AiSearchConversationValuesType {
  const entityValues = AiSearchConversationValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : aiSearchConversationDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
